module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showDeleted || _vm.form.status !== "DELETED") ? _c('v-list-tile', {
    key: _vm.form.id,
    class: _vm.getSelectedClasses,
    on: {
      "click": function($event) {
        return _vm.$emit("selected", _vm.form)
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-img', {
    attrs: {
      "src": _vm.jotformIcon
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.form.title)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', [(_vm.form.status && _vm.form.status === 'DISABLED') ? _c('v-chip', {
    staticClass: "v-chip--x-small ml-0",
    class: _vm.statusclasses,
    attrs: {
      "dark": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.form.status) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.form.linked_form) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "dark": "",
      "color": "success"
    }
  }, [_vm._v("\n        Linked\n      ")]) : _vm._e(), _vm._v(" "), (_vm.withNotifications) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "color": "info"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("notifications_active")]), _vm._v(" Notifcation\n      ")], 1) : _vm._e()], 1), _vm._v(" "), (_vm.form.spaces) ? _c('v-list-tile-sub-title', [_vm._v("\n      Installed in: "), _c('space-faces', {
    attrs: {
      "space-ids": _vm.form.spaces
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.readonly) ? [(_vm.form.linked_form) ? [_c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("chevron_right")])], 1)], 1)] : _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "outline": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit("link", _vm.form)
      }
    }
  }, [_vm._v("\n        Link")])], 1)] : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-865b4d72","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/JotForm/FormListItem.vue
// module id = 1669
// module chunks = 0